"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (err, errInfo) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            error: err,
            errorInfo: errInfo,
        };
    };
    ErrorBoundary.prototype.componentDidCatch = function (err, errInfo) {
        console.error('Uncaught error:', err, errInfo);
    };
    ErrorBoundary.prototype.render = function () {
        var _a, _b, _c, _d;
        if (this.state.hasError) {
            return (React.createElement("div", { style: { margin: '50px' } },
                React.createElement("h2", { className: "error" }, "Er is iets fout gegaan!"),
                React.createElement("br", null),
                process.env.NODE_ENV === 'development' ?
                    React.createElement("div", null,
                        React.createElement("details", { style: { whiteSpace: 'pre-wrap' } },
                            React.createElement("p", null, ((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message) || ''),
                            React.createElement("br", null),
                            React.createElement("p", null, ((_d = (_c = this.state) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.stack) || ''))) : React.createElement("p", null, "Neem contact op met de beheerder over deze fout.")));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
exports.default = ErrorBoundary;
